const Container = require('./Container');
const Alert = require('./Alert');

const options = {
    alertTime: 3,
    alertTimeRemove: 1
};

let container = null;

window.tatoxAlert = ({type, title, message}) => {
    try {
        if (!container) {
            container = new Container(options);
        }

        const alert = new Alert({type, title, message});
        container.addAlert(alert);
    } catch (error) {
        console.error(error.message)
    }
}
